import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

import Wrapper from '../wrapper'
import { transition, Media, color } from '../../style'

export const StyledHeader = styled.header`
  position: fixed;
  z-index: 10;
  top: 0;
  width: 100%;
  height: 80px;
  line-height: 80px;
  min-width: 1200px;
  background-color: ${(p) => (p.stick ? 'transparent' : 'rgba(0, 0, 0, 0.7)')};
  transition: ${transition('background-color')};
  ${Media.lessThan(Media.small)} {
    min-width: initial;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.7);
    img {
      height: 15px;
    }
  }
`
export const StyledWrapper = styled(Wrapper)`
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: space-between;
`
export const NavItem = styled((p) => <Link activeClassName='active' {...p} />)`
  color: white;
  line-height: 2;
  display: inline-block;
  text-decoration: none;
  transition: ${transition('color')};
  :hover {
    color: ${color.primary};
  }
  & + & {
    margin-left: 50px;
  }
  &.active {
    border-bottom: 2px solid ${color.primary};
  }
`
export const NavWrap = styled.div`
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`
export const IconWrap = styled.div`
  display: none;
  width: 1.5em;
  height: 1.5em;
  margin-left: 1em;
  transition: ${transition('transform')};
  ${Media.lessThan(Media.small)} {
    display: block;
  }
`
export const MenuIcon = styled.i`
  display: ${(p) => (p.isActive ? 'block' : 'none')};
  position: relative;
  font-style: normal;
  color: white;
  width: 100%;
  height: 2px;
  top: 0.75em;
  background-color: currentColor;
  ::before,
  ::after {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: currentColor;
  }
  ::before {
    top: -5px;
  }
  ::after {
    top: 5px;
  }
`
export const CloseIcon = styled.i`
  display: ${(p) => (p.isActive ? 'block' : 'none')};
  position: relative;
  font-style: normal;
  color: white;
  margin-top: 0;
  margin-left: 0;
  width: 100%;
  height: 100%;
  ::before,
  ::after {
    content: '';
    position: absolute;
    top: 0.65em;
    width: 100%;
    height: 2px;
    border-radius: 1px;
    background-color: currentColor;
  }
  ::before {
    transform: rotate(-45deg);
  }
  ::after {
    transform: rotate(45deg);
  }
`
export const MobileMenuContainer = styled.div`
  top: 40px;
  right: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.7);
  overflow: hidden;
  transition: ${transition(['height', 'padding'])};
  height: ${(props) => (props.isExpand ? '200px' : '0px')};
  max-width: 100%;
  padding: ${(props) => (props.isExpand ? '10px' : '0')} 0;
`
export const MobileTextLine = styled(Link)`
  color: white;
  text-decoration: none;
  height: 36px;
  line-height: 36px;
  padding: 0 2em;
`
